import { useDispatch } from 'react-redux';
import { dispatcher } from '../helpers/projectHelper';
import { infoDialogActions } from '../redux/slicers/infoDialogSlicer';

let resetTimerId = null;

export const openInfoDialog = (config) => {
  dispatcher(infoDialogActions.openInfoDialog({ ...config, dispatch: dispatcher }));
  clearTimeout(resetTimerId);
};

export const openYesNoDialog = (config) => {
  dispatcher(
    infoDialogActions.openInfoDialog({
      cancelButtonText: 'No',
      buttonText: 'Yes',
      theme: 'v2',
      closeable: false,
      ...config,
      dispatch: dispatcher,
    })
  );
  clearTimeout(resetTimerId);
};

export const openYesNoDialogPromise = async (config) => {
  return new Promise(resolve => {
    openYesNoDialog({
      ...config,
      onButtonClick: () => resolve(true),
      onCancelClick: () => resolve(false),
    })
  })
}


export const useInfoDialogaActions = () => {
  const dispatch = useDispatch();
  return {
    /**
     * @param {{
     *  title: any;
     *  content?: any;
     *  buttonText?: any;
     *  cancelButtonText?: any;
     *  onButtonClick?: () => Promise<void> | void;
     *  onCancelClick?: () => void;
     *  onClose?: () => void;
     *  okBtnColor?: any;
     *  cancelBtnColor?: any;
     *  okBtnClassName?: any;
     * }} config
     * @returns void
     */
    openInfoDialog,
    closeInfoDialog: () => {
      dispatch(infoDialogActions.closeInfoDialog());

      resetTimerId = setTimeout(() => {
        dispatch(infoDialogActions.reset());
      }, 200);
    },
    clearInfoDialog: () => {
      dispatch(infoDialogActions.closeInfoDialog());
      dispatch(infoDialogActions.reset());
      dispatch(infoDialogActions.resetQueue());
    },
  };
};
